import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxEditorModule } from "ngx-editor";
import { BtnSendEmailComponent } from "../views/email/btn-send-email/btn-send-email.component";
import { SendEmailComponent } from "../views/email/send-email/send-email.component";
import { ArchivosModule } from "./archivos.module";
import { SharedModule } from "./shared.module";
import { TestEmailModalComponent } from "@views/email/test-email-modal/test-email-modal.component";

@NgModule({
  imports: [
      CommonModule,
      SharedModule,
      ArchivosModule
  ],
  declarations: [
    SendEmailComponent,
    BtnSendEmailComponent,
    TestEmailModalComponent
  ],
  providers: [
  ],
  exports: [
    SendEmailComponent,
    BtnSendEmailComponent,
    TestEmailModalComponent
  ]
})
export class EmailModule { }
